import copy from 'copy-to-clipboard';

const copyToClipboard = (text, callback) => {
  if (typeof text === 'string' || typeof text === 'number') {
    copy(text.toString());

    callback && callback();
  }
};

export default copyToClipboard;
